import styled from 'styled-components';

/**
 * A row of toggles, the toggles sharing the width equally so they never wrap onto a second line.
 * `$columns` is the grid-template-columns, e.g. `repeat(3, minmax(0, 1fr))`.
 */
export const ToggleChipRow = styled.div<{ $columns: string }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns};
  gap: 4px;
`;

/**
 * A toggle button: an outline until it is on, then filled with `$color`. The one control for "pick
 * any of these" - the side panel's status and kind filters, the channels a customer is notified on.
 * `$size="large"` is the form-sized one, and `"small"` the compact form's: their heights are those of
 * antd's Segmented in the same sizes (32px and 24px), so a row of toggles sits level with a segmented
 * control above or below it.
 */
export const ToggleChip = styled.button<{ $on: boolean; $color: string; $size?: 'default' | 'large' | 'small' }>`
  min-width: 0;
  box-sizing: border-box;
  ${({ $size }) => ($size === 'large' ? 'height: 32px;' : $size === 'small' ? 'height: 24px;' : '')}
  padding: ${({ $size }) => ($size === 'large' ? '0 8px' : $size === 'small' ? '0 4px' : '3px 4px')};
  border-radius: ${({ $size }) => ($size === 'large' ? '8px' : '6px')};
  border: 1px solid ${({ $on, $color }) => ($on ? $color : '#d0d7de')};
  background: ${({ $on, $color }) => ($on ? $color : '#fff')};
  color: ${({ $on }) => ($on ? '#fff' : '#555')};
  font-family: inherit;
  font-size: ${({ $size }) => ($size === 'large' ? '13px' : '11px')};
  font-weight: ${({ $on }) => ($on ? 600 : 500)};
  line-height: ${({ $size }) => ($size === 'large' ? '30px' : $size === 'small' ? '22px' : '18px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: ${({ $color }) => $color};
  }

  &:disabled {
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.25);
    background: #f5f5f5;
    border-color: #e6e6e6;
  }
`;
